import React from "react";
import { ButtonStyled } from "./Button.styled";

function RippleButton({ onClick, children }) {
  return <ButtonStyled onClick={onClick} className="btn-play">{children}</ButtonStyled>;
}

export default RippleButton;
